import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AppComponent } from '../../app.component';
import { BaseService } from '../../shared/services/base.service';
import { User } from '../../shared/models/user.interface';
import { Role } from '../../shared/models/role.interface';
import { RolePermissions } from '../../shared/models/rolePermissions.interface';
import { Office } from '../../shared/models/office.interface';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { Authentication } from '../../shared/models/authentication.interface';

@Injectable()

export class UserService extends BaseService {

  constructor(private appComponent: AppComponent, protected http: HttpClient, router: Router) {
    super(http, router);
  }

  getUser(userId): Observable<User> {
    return this.httpGet<User>("/user/" + userId);
  }

  getList(status: boolean): Observable<User[]> {
    let params = new HttpParams();
    if (status != null) {
      params = params.append('status', status.toString());
    }
    return this.httpGet<User[]>("/user?" + params.toString());
  }

  getUserPerms(userId): Observable<number[]> {
    return this.httpGet<number[]>("/user/" + userId + "/permissions");
  }

  updateLocale(locale: string): Observable<Authentication> {
    return this.httpPost<any>("/user/locale", locale);
  }

  updateCalendarView(calendarView: string): Observable<Authentication> {
    return this.httpPut<any>("/user/calendarView", calendarView);
  }

  expireToken(): Observable<any> {
    return this.httpPost<any>("/user/logout", null);
  }

  saveUser(user: User): Observable<User> {
    if (user.id == null)
      return this.httpPost<User>("/user/", user);
    else
      return this.httpPut<User>("/user/" + user.id, user);
  }

  toggleStatus(id: number): Observable<User> {
    return this.httpPut<User>("/user/toggle/" + id, null);
  }

  checkAvailableLicenses(dealerId: number, roleId: number): Observable<boolean> {
    let url = "/user/licenseAvailable" + '?dealerId=' + dealerId + '&roleId=' + roleId;

    return this.httpGet<boolean>(url);
  }
}
